import { AuthenticationService } from './../../base-services/authentication.service';
import { SideMenuService } from './side-menu.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SideMenu } from '../../base-models/side-menu';
import { Router } from '@angular/router';
import { ConfigService } from '../../base-services/config.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'yt-fw-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideMenuComponent implements OnInit {

  constructor(private baseDataService: BaseDataService,
              public sideMenuService: SideMenuService,
              private router: Router,
              private authenticationService: AuthenticationService,
              private configService: ConfigService,
              private changeDetectorRef: ChangeDetectorRef) { }

  sideMenuCollapsed: boolean = true;
  items = [];
  autoClose: boolean = false;
  private _isAuthenticated: boolean = false;
  loading: boolean = false;
  expandedIDs: number[] = [];

  @Input() IsTransparent: boolean = false;

  private unsubscribe$ = new Subject<void>();

  ngOnInit() {
    this.sideMenuService.SideMenuCollapsed
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        if(value){
          this.expandedIDs = this.setExpandedIDs(this.items, this.expandedIDs);
          if(this.items)
          this.items.forEach(item => {
            item.Expanded = false;
          })
        }
        else if(this.sideMenuCollapsed){
          //this.getItemByUrl(this.items);
          this.getExpandedIDs(this.items);
        }
        this.sideMenuCollapsed = value;
        this.changeDetectorRef.markForCheck();
      })

    this.authenticationService.IsAuthenticated
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(isAuthenticated => {
        this._isAuthenticated = isAuthenticated;
        //console.log('sidemenu isauthenticated ' + isAuthenticated);
        if(!this._isAuthenticated){
          this.items = null;
          this.changeDetectorRef.markForCheck();
        }
          //this.loadItems();
        //else{
          //this.items = null;
          //console.log('sidemenu null');
        //}
      })

      this.configService.SelectedOrgJed
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(selectedOrgJed => {
          this.items = null;
          this.changeDetectorRef.markForCheck();
          if(selectedOrgJed != null && selectedOrgJed.ID && selectedOrgJed.ID > 0){
            this._isAuthenticated = true;
            this.loadItems();
          }
          else
            this.items = null;
            this.changeDetectorRef.markForCheck();
        })
    }

    private loadItems(){
      let __this = this;
      setTimeout(function(){
      if(__this._isAuthenticated){
        __this.loading = true;
        __this.changeDetectorRef.markForCheck();
        __this.baseDataService.Get('menuItem', 'get', [], SideMenu)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(data => {
            if(__this._isAuthenticated)
              __this.items = data;
              __this.loading = false;
              __this.changeDetectorRef.markForCheck();
          })
      }
    }, 500);
  }

  ItemSelected(item){
    //if(item.SubMenu != null && item.SubMenu.length > 0){
      //item.Expanded = true;
      //this.sideMenuService.SetSideMenuCollapseWithValue(false);
    //}
    item.Expanded = !item.Expanded;
    if(!item.Expanded)
      this.expandedIDs = this.expandedIDs.splice(this.expandedIDs.indexOf(item.ID), 1);
    this.sideMenuService.SetSideMenuCollapseWithValue(false);
  }

  SubItemSelected(url: string){
    //this.router.navigate(['./' + url.toLowerCase()]);
    //alert('rewrwe');
    if(this.autoClose)
      this.sideMenuService.SetSideMenuCollapseWithValue(true);
  }

  private getItemByUrl(items:SideMenu[]){
    let url = this.router.url;
    let sideMenuItem = null;
    if(items){
      items.forEach((item: SideMenu) => {
        if(item["Url"] == url){
          sideMenuItem = item;
        }
        if(item["SubMenu"] != null)
          this.getItemByUrl(item["SubMenu"]);
      })
    }
    return sideMenuItem;
  }

  private setExpandedIDs(items: SideMenu[], expandedIDs: number[]){
    //let expandedIDs: number[];
    expandedIDs = [];
    if(items){
      items.forEach((item: SideMenu) => {
        if(item["Expanded"])
          expandedIDs.push(item.ID);
        if(item.SubMenu != null)
          this.setExpandedIDs(item.SubMenu, expandedIDs);
      })
    }
    return expandedIDs;
  }

  private getExpandedIDs(items: SideMenu[]){
    if(items){
      items.forEach((item: SideMenu) => {
        if(this.expandedIDs.indexOf(item.ID) > -1)
          item["Expanded"] = true;
        if(item.SubMenu != null)
          this.getExpandedIDs(item.SubMenu);
      })
    }
  }
  
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
